// components/InputFieldGroup.js
import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";

import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import CustomSelect from "../components/CustomSelect";
import FontFamilySelect from "../components/FontFamilySelect";

const InputGroup = () => {
  const { state, dispatch } = useContext(FormBuilderContext);

  const handleColorChange = (actionType) => (color) => {
    dispatch({ type: actionType, payload: color });
  };

  const handleFontWeightChange = (event) => {
    dispatch({
      type: ACTIONS.INPUT_FONT_WEIGHT_INPUT,
      payload: event.target.value,
    });
  };

  const handleInputWidthUnitsChange = (event) => {
    dispatch({
      type: ACTIONS.INPUT_WIDTH_UNITS,
      payload: event.target.value,
    });
  };

  const handleFontFamilyChange = (event) => {
    dispatch({
      type: ACTIONS.INPUT_FONT_FAMILY_CHANGE,
      payload: event.target.value,
    });
  };

  return (
    <>
      <div className="input-group-wrapper">
        {/* ################################################################################ */}

        <InputSection
          id="fieldTopSpacing"
          title="Spacing above"
          value={state.fieldTopSpacing}
          actionTypeIncrement={ACTIONS.FIELD_TOP_SPACING_INCREMENT}
          actionTypeDecrement={ACTIONS.FIELD_TOP_SPACING_DECREMENT}
          actionTypeInput={ACTIONS.FIELD_TOP_SPACING_INPUT}
          dispatch={dispatch}
        />

        <InputSection
          id="inputPaddingInline"
          title="Inline padding"
          value={state.inputPaddingInline}
          actionTypeIncrement={ACTIONS.INPUT_INLINE_PADDING_INCREMENT}
          actionTypeDecrement={ACTIONS.INPUT_INLINE_PADDING_DECREMENT}
          actionTypeInput={ACTIONS.INPUT_INLINE_PADDING_INPUT}
          dispatch={dispatch}
        />
      </div>
      <h2 className="section-subheader">Field styles</h2>
      <div className="input-group-wrapper">

        <InputSection
          id="inputHeight"
          title="Input field height"
          value={state.inputHeight}
          actionTypeIncrement={ACTIONS.INPUT_HEIGHT_INCREMENT}
          actionTypeDecrement={ACTIONS.INPUT_HEIGHT_DECREMENT}
          actionTypeInput={ACTIONS.INPUT_HEIGHT_INPUT}
          dispatch={dispatch}
        />

        <InputSection
          id="inputWidth"
          title="Input field width"
          value={state.inputWidth}
          actionTypeIncrement={ACTIONS.INPUT_WIDTH_INCREMENT}
          actionTypeDecrement={ACTIONS.INPUT_WIDTH_DECREMENT}
          actionTypeInput={ACTIONS.INPUT_WIDTH_INPUT}
          dispatch={dispatch}
        />

        <div>
          <p>Width by units</p>
          <CustomSelect
            labelId="width-by-units"
            id="width-by-units"
            selectValue={state.inputWidthUnits}
            selectLabel="Width by units"
            selectOnChange={handleInputWidthUnitsChange}
            menuItems={[
              { value: "%", label: "%" },
              { value: "px", label: "px" },
            ]}
          />
        </div>

      </div>
      <h2 className="section-subheader">Font styles</h2>
      <div className="input-group-wrapper">

        <div className="form-builder-section-div">
          <p>Font Family</p>
          <FontFamilySelect
          selectedFontFamily={state.inputFontFamily}
          onFontFamilyChange={handleFontFamilyChange}
        />
          {/* <div className="input-div">
            <input
              type="text"
              id="input_font-family"
              value={state.inputFontFamily}
              onChange={(e) =>
                dispatch({
                  type: ACTIONS.INPUT_FONT_FAMILY_INPUT,
                  payload: e.target.value,
                })
              }
            />
          </div> */}
        </div>

        <InputSection
          id="inputFontSize"
          title="Font size"
          value={state.inputFontSize}
          actionTypeIncrement={ACTIONS.INPUT_FONT_SIZE_INCREMENT}
          actionTypeDecrement={ACTIONS.INPUT_FONT_SIZE_DECREMENT}
          actionTypeInput={ACTIONS.INPUT_FONT_SIZE_INPUT}
          dispatch={dispatch}
        />
        <div>
          <p>Font Weight</p>
          <CustomSelect
            labelId="font-weight-select-label"
            id="font-weight-select"
            selectValue={state.inputFontWeight}
            selectLabel="Font Weight"
            selectOnChange={handleFontWeightChange}
            menuItems={[
              { value: 100, label: "100" },
              { value: 200, label: "200" },
              { value: 300, label: "300" },
              { value: 400, label: "400" },
              { value: 500, label: "500" },
              { value: 600, label: "600" },
              { value: 700, label: "700" },
              { value: 800, label: "800" },
              { value: 900, label: "900" },
            ]}
          />
        </div>
      </div>
      <h2 className="section-subheader">Border styles </h2>
      <div className="form-builder-section-div-checkmark">
        <input
          type="checkbox"
          checked={state.inputBorderStyleCheckbox === "none"}
          onChange={() => dispatch({ type: ACTIONS.INPUT_TOGGLE_BORDER_STYLE })}
        />
        <p>Border bottom only?</p>
      </div>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Border Color</p>
          <ColorPickerInput
            color={state.inputBorderColor}
            onChange={handleColorChange(ACTIONS.INPUT_BORDER_COLOR_INPUT)}
          />
        </div>
        <InputSection
          id="inputBorderWidth"
          title="Border width"
          value={state.inputBorderWidth}
          actionTypeIncrement={ACTIONS.INPUT_BORDER_WIDTH_INCREMENT}
          actionTypeDecrement={ACTIONS.INPUT_BORDER_WIDTH_DECREMENT}
          actionTypeInput={ACTIONS.INPUT_BORDER_WIDTH_INPUT}
          dispatch={dispatch}
        />

        {/* ################################################################################ */}

        <InputSection
          id="inputBorderRadius"
          title="Border radius"
          value={state.inputBorderRadius}
          actionTypeIncrement={ACTIONS.INPUT_BORDER_RADIUS_INCREMENT}
          actionTypeDecrement={ACTIONS.INPUT_BORDER_RADIUS_DECREMENT}
          actionTypeInput={ACTIONS.INPUT_BORDER_RADIUS_INPUT}
          dispatch={dispatch}
        />
      </div>
      {/* ################################################################################ */}
      <h2 className="section-subheader">Color styles </h2>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Text Color</p>
          <ColorPickerInput
            color={state.inputColor}
            onChange={handleColorChange(ACTIONS.INPUT_COLOR_INPUT)}
          />
        </div>

        <div className="form-builder-section-div">
          <p>Background Color</p>
          <ColorPickerInput
            color={state.inputBackgroundColor}
            onChange={handleColorChange(ACTIONS.INPUT_BACKGROUND_INPUT)}
          />
        </div>
      </div>
      {/* ################################################################################ */}

      {/* ################################################################################ */}

      <h2 className="section-subheader">Hover styles </h2>
      <div className="input-group-wrapper">
        <div className="form-builder-section-div">
          <p>Text Color</p>
          <ColorPickerInput
            color={state.inputHoverColor}
            onChange={handleColorChange(ACTIONS.INPUT_HOVER_COLOR_INPUT)}
          />
        </div>

        {/* ################################################################################ */}

        <div className="form-builder-section-div">
          <p>Border Color</p>
          <ColorPickerInput
            color={state.inputHoverBorderColor}
            onChange={handleColorChange(ACTIONS.INPUT_HOVER_BORDER_COLOR_INPUT)}
          />
        </div>

        {/* ################################################################################ */}

        <div className="form-builder-section-div">
          <p>Background Color</p>
          <ColorPickerInput
            color={state.inputHoverBackgroundColor}
            onChange={handleColorChange(ACTIONS.INPUT_HOVER_BACKGROUND_INPUT)}
          />
        </div>
      </div>
    </>
  );
};

export default InputGroup;
